// get browser type
const { detect } = require('detect-browser')
const browserType = detect()
// get browser language
const detectBrowserLanguage = require('detect-browser-language')
const browserLang = detectBrowserLanguage()
// install our plugin
const Creo = {
	install(Vue, options) {
		Vue.prototype.$creo = {
			// get browser pdf link depending on browser
			browserPdfLink(org, fallback, page) {
				if(browserType) {
					const bName = browserType.name
					if(bName === 'chrome' || bName === 'opera' || bName === 'firefox') {
						return org + '#page=' + page
					} else {
						return fallback
					}
				} else {
					return fallback
				}
			},
			// get current language
			getLang() {
				// const queryString = window.location.search;
				// const urlParams = new URLSearchParams(queryString);
				// const lang = urlParams.get('lang');
				const lang = 'sv'
				return lang ? lang : 'en';
			},
			get_browser() {
		       var ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
		       if (window.navigator.userAgent.indexOf("Edge") > -1) {
		         tem = ua.match(/\Edge\/(\d+)/)
		         if (tem != null) { return tem[1] < 79 ? false : true }
		       }
		       return true
			 ;
		   },
		}
	}
}

export default Creo
